<template>
  <div class="mobile-toast-container">
    <transition name="toast-slide">
      <div
        v-if="notification.message"
        class="mobile-toast"
        :class="[toastClass, { 'blinking-toast': isBlinking }]"
        @click="dismiss"
      >
        <i :class="['bi', iconClass, 'toast-icon']"></i>
        <span class="toast-text">{{ notification.message }}</span>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'MobileToastNotification',
  props: {
    notification: {
      type: Object,
      default: () => ({ message: '', type: 'info' })
    },
    isBlinking: {
      type: Boolean,
      default: false
    }
  },
  emits: ['dismiss'],
  computed: {
    toastClass () {
      return `toast-${this.notification.type || 'info'}`
    },
    iconClass () {
      switch (this.notification.type) {
        case 'success': return 'bi-check-circle-fill'
        case 'error': return 'bi-x-circle-fill'
        case 'warning': return 'bi-exclamation-triangle-fill'
        default: return 'bi-info-circle-fill'
      }
    }
  },
  methods: {
    dismiss () {
      this.$emit('dismiss')
    }
  }
}
</script>

<style scoped>
.mobile-toast-container {
  position: fixed;
  bottom: 68px; /* 56px tab bar + 12px gap */
  left: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  pointer-events: none;
  z-index: 10060;
}

.mobile-toast {
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: calc(100vw - 32px);
  padding: 10px 16px;
  border-radius: 12px;
  font-size: 0.85rem;
  font-weight: 500;
  color: #fff;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
  pointer-events: auto;
  cursor: pointer;
  backdrop-filter: blur(8px);
}

.toast-icon {
  font-size: 1.1rem;
  flex-shrink: 0;
}

.toast-text {
  flex: 1;
  line-height: 1.3;
}

.toast-success {
  background: rgba(25, 135, 84, 0.92);
}
.toast-error {
  background: rgba(220, 53, 69, 0.92);
}
.toast-warning {
  background: rgba(255, 193, 7, 0.92);
  color: #000;
}
.toast-info {
  background: rgba(13, 202, 240, 0.92);
  color: #000;
}

/* Animação de blink (mesma do desktop: 0.2s, steps(1)) */
.blinking-toast {
  animation: toast-blink-animation 0.2s steps(1, start) infinite;
}

@keyframes toast-blink-animation {
  from { opacity: 1; }
  to { opacity: 0; }
}

/* Transição: sobe de baixo com fade */
.toast-slide-enter-active {
  transition: all 0.35s cubic-bezier(0.2, 0.8, 0.2, 1);
}
.toast-slide-leave-active {
  transition: all 0.25s ease-in;
}
.toast-slide-enter-from {
  opacity: 0;
  transform: translateY(20px);
}
.toast-slide-leave-to {
  opacity: 0;
  transform: translateY(10px);
}
</style>
